<template>

<div class="nodes-tree" v-loading="isLoading">
<div v-if="data.length === 0">
  <el-button type="primary" @click="onClickAddChildNodeBtn">创建初始节点</el-button>
</div>

  <el-input
    placeholder="输入关键字进行过滤"
    v-model="filterText">
  </el-input>
  <el-tree
    ref="tree"
    :data="data"
    :props="defaultProps"
    node-key="nodeCode"
    @current-change="onCurrentChange"
    draggable
    default-expand-all
    @node-drop="handleDrop"
    :allow-drop="allowDrop"
    :filter-node-method="filterNode"
  >
    <div class="custom-tree-node" slot-scope="{node, data}">
      <span class="text">{{ node.label }}</span>
      <span class="opts">
          <el-popover
            placement="bottom"
            popper-class="node-tree-custom-popper"
            trigger="hover"
            transition="none"
            @show="opOptsPopoverShow(data)"
          >
            <span class="btn" slot="reference">
              <icon iconName="icon-gengduocaozuo"/>
            </span>
            <el-scrollbar wrap-class="btns-list">
              <div class="btns-item" @click="onClickAddChildNodeBtn">添加子节点</div>
              <div class="btns-item" @click="onClickAddSiblingNodeBtn">添加平级节点</div>
              <div class="btns-item" @click="onClickAddAttrBtn">添加标签</div>
              <div class="btns-item" @click="onClickAddMemberBtn">添加对象</div>
              <div class="btns-item" @click="onClickDelBtn">删除</div>
            </el-scrollbar>
          </el-popover>
        </span>
    </div>
  </el-tree>

 <el-dialog
    title="添加节点"
    :visible.sync="isCreateNodeDialogVisible"
    width="30%"
    :modalAppendToBody="false"
  >
    <el-input v-model="newNodeCode" placeholder="请输入编码"></el-input>
    <el-input v-model="newNodeName" placeholder="请输入名称"></el-input>
    <span slot="footer" class="dialog-footer">
        <el-button @click="isCreateNodeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickCreateNodeSubmitBtn">确 定</el-button>
      </span>
  </el-dialog>
</div>
</template>

<script>
import {components} from '@x-tech/fe-puma-lib';

const {Icon} = components;
import {getAllNodeByGroup, deleteNodeFromGroup, createNode, editGroupNode} from '../../../apis';

const NEW_NODE_POSITION_SIBLING = 'NEW_NODE_POS_SIBLING';
const NEW_NODE_POSITION_CHILDREN = 'NEW_NODE_POS_CHILDREN';

const NODE_POSITION_INNER = 'inner';
const NODE_POSITION_AFTER = 'after';
const NODE_POSITION_BEFORE = 'before';

// 对 el-tree 的简单封装，增加了节点上的操作菜单

export default {
  name: 'NodesTree',
  components: {
    Icon
  },
  props: {
    groupCode: {
      type: String,
      required: true
    },
    nodeKey: {
      type: String,
      default() {
        return 'nodeCode';
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'child',
          label: 'nodeName',
          id: 'nodeCode'
        };
      }
    }
  },
  data() {
    return {
      filterText: '',

      isLoading: false,
      data: [],
      crtNodeData: {},

      parentCode: '',
      isCreateNodeDialogVisible: false,
      newNodeCode: '',
      newNodeName: '',
      newNodePosition: NEW_NODE_POSITION_CHILDREN
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  async mounted() {
    this.isLoading = true;
    let res = await getAllNodeByGroup(this.groupCode);
    this.data = res;
    this.isLoading = false;
  },
  methods: {
    filterNode(value, data) {
        if (!value) return true;
        return data.nodeName.indexOf(value) !== -1;
    },
    opOptsPopoverShow(node = '') {
      if (node.nodeCode) {
        this.crtNodeData = node;
        this.$emit('update:crtNodeDataHover', node);
      }
    },
    $_closeCreateNodeDialog() {
      this.newNodeCode = '';
      this.newNodeName = '';
      this.isCreateNodeDialogVisible = false;
    },
    onCurrentChange(crtData = {}) {
      this.$emit('update:crtNodeData', crtData);
    },
    async onClickCreateNodeSubmitBtn() {
      if (this.newNodePosition === NEW_NODE_POSITION_CHILDREN) {
        let res = await createNode(this.groupCode, this.newNodeCode, this.newNodeName, this.crtNodeData.nodeCode);
        this.$refs.tree.append(
          {
            nodeCode: this.newNodeCode,
            nodeName: this.newNodeName
          },
          this.crtNodeData.nodeCode
        );
      } else if (this.newNodePosition === NEW_NODE_POSITION_SIBLING) {
        let crtNode = this.$refs.tree.getNode(this.crtNodeData.nodeCode);
        let parent;
        if (crtNode) {
          parent = crtNode.parent;
          let res = await createNode(this.groupCode, this.newNodeCode, this.newNodeName, parent.data.nodeCode);
          this.$refs.tree.insertAfter(
            {
              nodeCode: this.newNodeCode,
              nodeName: this.newNodeName
            },
            this.crtNodeData.nodeCode
          );
        }
      }
      this.$_closeCreateNodeDialog();
    },
    onClickAddChildNodeBtn() {
      this.isCreateNodeDialogVisible = true;
      this.newNodePosition = NEW_NODE_POSITION_CHILDREN;
    },
    onClickAddSiblingNodeBtn() {
      this.isCreateNodeDialogVisible = true;
      this.newNodePosition = NEW_NODE_POSITION_SIBLING;
    },
    onClickAddAttrBtn() {
      this.$emit('clickAddAttrBtn', {nodeCode: this.crtNodeData.nodeCode});
    },
    onClickAddMemberBtn() {
      this.$emit('clickAddMemberBtn', {nodeCode: this.crtNodeData.nodeCode});
    },
    async onClickDelBtn() {
      await this.$confirm('是否确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      });
      await deleteNodeFromGroup(this.groupCode, this.crtNodeData.nodeCode);
      this.$refs.tree.remove(this.crtNodeData.nodeCode);
    },
    async handleDrop(draggingNode, dropNode, dropType, event) {
      let draggingNodeData = draggingNode.data;
      let dropNodeData = dropNode.data;
      if (dropType === 'inner') {
        let res = await editGroupNode(
          this.groupCode,
          draggingNodeData.nodeCode,
          draggingNodeData.nodeName,
          dropNodeData.nodeCode
        );
      } else if (dropType === 'after' || dropType === 'before') {
        if (dropNode.parent.level === 0) {
          let res = await editGroupNode(this.groupCode, draggingNodeData.nodeCode, draggingNodeData.nodeName);
        } else {
          let res = await editGroupNode(
            this.groupCode,
            draggingNodeData.nodeCode,
            draggingNodeData.nodeName,
            dropNode.parent.data.nodeCode
          );
        }
      } else {
        console.log('unknow dropType');
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (type === NODE_POSITION_INNER) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  }
};
</script>

<style>
.node-tree-custom-popper {
  width: 155px;
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-popover {
  padding: 0 !important;
}

::v-deep .el-tree-node__children {
  transition: none;
}

%active-node {
  background: #f5f7fa;
  border-left: 2px solid #b81b22;
}

::v-deep .is-current > .el-tree-node__content {
  @extend %active-node;
}

::v-deep .el-tree-node__content {
  box-sizing: border-box;
  border-left: 2px solid #fff;

  &:hover {
    @extend %active-node;
  }
}

.nodes-tree {
  padding: 20px 0;
  height: 100%;
}

.custom-tree-node {
  font-size: 12px;
  font-weight: 400;
  color: #222;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .text {
  }

  .opts {
    display: none;
    margin-left: 4px;
  }

  &:hover {
    .opts {
      display: inline-block;
    }
  }

  .btn {
    ::v-deep .iconfont {
      font-size: 12px;
      color: #b0b6c1;

      &:hover {
        color: #b81b22;
      }
    }
  }
}

.btns-list {
  max-height: 100px;
}

.btns-item {
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #303133;
  cursor: pointer;

  &:hover {
    background: #f4f7fa;
  }
}
</style>
